// plugins/global-methods.js
import Vue from 'vue'
import { filterDictText, formatAmount, showPageError } from '~/utils'

Vue.prototype.$filterDictText = (dictOptions, text) => filterDictText(dictOptions, text)
Vue.prototype.$formatAmount = (value) => formatAmount(value)
Vue.prototype.$showPageError = function (err) {
  showPageError(this.$router, err)
}